// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value_your_trade_info[data-v-fbf24d8c] {
  max-width: fit-content;
  padding: 30px;
}
.value_your_trade_info_details[data-v-fbf24d8c] {
  min-width: 300px;
}
.value_your_trade_info_details p[data-v-fbf24d8c] {
  margin-bottom: 0;
  padding: 15px 0;
}
.gap_60[data-v-fbf24d8c] {
  gap: 60px;
}
.value_your_trade_graphic .iframe_box[data-v-fbf24d8c] {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0 0 0;
  height: 400px;
}
.value_your_trade_graphic iframe[data-v-fbf24d8c] {
  height: 100%;
  display: block;
  margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiKbbTradeValue.vue","webpack://./AiKbbTradeValue.vue"],"names":[],"mappings":"AACA;EACE,sBAAA;EACA,aAAA;ACAF;ADGA;EACE,gBAAA;ACDF;ADAA;EAII,gBAAA;EACA,eAAA;ACDJ;ADKA;EACE,SAAA;ACHF;ADMA;EAGI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;ACNJ;ADDA;EAWI,YAAA;EACA,cAAA;EACA,YAAA;ACPJ","sourcesContent":["\n.value_your_trade_info {\n  max-width: fit-content;\n  padding: 30px;\n}\n\n.value_your_trade_info_details {\n  min-width: 300px;\n\n  p {\n    margin-bottom: 0;\n    padding: 15px 0;\n  }\n}\n\n.gap_60 {\n  gap: 60px;\n}\n\n.value_your_trade_graphic {\n\n  .iframe_box {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 5px 0 0 0;\n    height: 400px;\n  }\n\n  iframe {\n    height: 100%;\n    display: block;\n    margin: auto;\n  }\n}\n",".value_your_trade_info {\n  max-width: fit-content;\n  padding: 30px;\n}\n.value_your_trade_info_details {\n  min-width: 300px;\n}\n.value_your_trade_info_details p {\n  margin-bottom: 0;\n  padding: 15px 0;\n}\n.gap_60 {\n  gap: 60px;\n}\n.value_your_trade_graphic .iframe_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 5px 0 0 0;\n  height: 400px;\n}\n.value_your_trade_graphic iframe {\n  height: 100%;\n  display: block;\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
